<template>
  <!--新品检验-样检单查看-->
  <h-form-page-new :title="h_i18n('23928ed42a148cce2253f2fe636b6b2b')" @inspection-update="inspectionUpdate" style="background: #F2F4F7;padding:16px;">
    <!-- 基本信息 -->
    <form-header-new :title="h_i18n('9e5ffa068ed435ced73dc9bf5dd8e09c')" style="margin-top: 10px;">
      <template #body>
        <div class="detail-content" style="margin-top: 16px;">
          <div class="detail-item">
            <!-- 样检单号： -->
            <div class="item-label">{{ h_i18n('0dfedd58f37571cc86caec5f09366bdb') }}</div>
            <div class="item-content">{{ typeToValue(beforeData.patternPlanId) }}</div>
          </div>
          <div class="detail-item">
            <!-- 检验方式： -->
            <div class="item-label">{{ h_i18n('62d773f2fea6b5cc3313bfa1d0af5df4') }}</div>
            <div class="item-content">{{ typeToValue(tableList.checkTypeName) }}</div>
          </div>
          <div class="detail-item">
            <!-- 工厂小微： -->
            <div class="item-label">{{ h_i18n('2153e04c74140dd4926dd724aad0d2a7') }}</div>
            <div class="item-content">{{ typeToValue(tableList.sybId) + '-'}}{{ typeToValue(tableList.sybName) }}</div>
          </div>
          <div class="detail-item">
            <!-- 专用号： -->
            <div class="item-label">{{ h_i18n('7c7fefb36371a5a9ab5338c98790c67c') }}</div>
            <div class="item-content">{{ typeToValue(tableList.mtlNo) }}</div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 物料描述： -->
            <div class="item-label">{{ h_i18n('ae0a6cd4dc95ffac4ef5ec67199d363a') }}</div>
            <div class="item-content">{{ typeToValue(tableList.mtlName) }}</div>
          </div>
          <div class="detail-item">
            <!-- 物料大类： -->
            <div class="item-label">{{ h_i18n('70ab9180fbc7101df91637a8c7372a7c') }}</div>
            <div class="item-content">{{ typeToValue(tableList.materielCategoryName) }}</div>
          </div>
          <div class="detail-item">
            <!-- 供应商代码： -->
            <div class="item-label">{{ h_i18n('15be0cbf984ead7733f52bbd01db11a2') }}</div>
            <div class="item-content">{{ typeToValue(tableList.supplyCode) }}</div>
          </div>
          <div class="detail-item">
            <!-- 供应商名称： -->
            <div class="item-label">{{ h_i18n('eb0e130294c8c3b3fa2cfecc849fec49') }}</div>
            <div class="item-content">{{ typeToValue(tableList.supplyName) }}</div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 产品编码： -->
            <div class="item-label">{{ h_i18n('7ca3d20b6df0d10179e222f202da6bc8') }}</div>
            <div class="item-content">{{ typeToValue(tableList.matchingModel) }}</div>
          </div>
          <div class="detail-item">
            <!-- 供方检验资格： -->
            <div class="item-label">{{ h_i18n('be5067b9c3d89ddada898b2dfb7a40c4') }}</div>
            <div class="item-content">{{ supplyCheckFormatter(tableList.supplyCheckLevel) }}</div>
          </div>
          <div class="detail-item">
            <!-- 计划生成时间： -->
            <div class="item-label">{{ h_i18n('71659f5eaba3d094009a9be961059e43') }}</div>
            <div class="item-content">{{ time(tableList.sendDay, 6) }}</div>
          </div>
        </div>
      </template>
    </form-header-new>
    <!-- <form-area :title="['自检审核','物料检验','研发确认','检验校核']"> -->
    <!-- 资料审核；制版设计稿；物料检验；外检结论；开发总结论 -->
    <form-area-new :title="tableList.isTemplet == 'Y' ? [h_i18n('100cf1ffb5463c11b5a447658c092cf5'),h_i18n('2f4fd79b3f9b4a273afa62295ab7db6a'),h_i18n('f6ef08d35df7a465a265e6283ce8b80c'),h_i18n('4112c666805c8646fa5fc69a453f2f88'),h_i18n('74efc164b99926adcc8746ded2434e15')] : [h_i18n('100cf1ffb5463c11b5a447658c092cf5'),h_i18n('f6ef08d35df7a465a265e6283ce8b80c'),h_i18n('4112c666805c8646fa5fc69a453f2f88'),h_i18n('74efc164b99926adcc8746ded2434e15')] ">
      <template #default="{value}">
        <!-- 资料审核 -->
        <form-body-new v-if="value===h_i18n('100cf1ffb5463c11b5a447658c092cf5')">
          <tr class="myTr">
            <!-- 自检报告提交人 -->
            <report-td-new colspan="3:5" :title="h_i18n('0f9e7f25f268037327547e57aeae6d4a')">
              <span v-if="tableList.isTemplet == 'Y'">{{ typeToValue(templetData.submitMan) }}</span>
              <span v-else>{{ typeToValue(mainData.submitMan) }}</span>
            </report-td-new>
            <!-- 自检报告应提交时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('1e91d74546aa6c4473ea637476e8497f')">{{ time(tableList.supplierSelfCheckPlanDate, 3) }}</report-td-new>
            <!-- 自检报告实提交时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('3b3b38dad08af058e8beeb6815aa35b8')">{{ time(tableList.selfCheckDate, 6) }}</report-td-new>
          </tr>
          <!-- <tr>
            <report-td colspan="3:5" title="供方-自检报告批准人">{{ typeToValue(mainData.supplyAuditMan) }}</report-td>
            <report-td colspan="3:5" title="供方-自检报告批准时间">{{ time(mainData.supplyAuditDate, 6) }}</report-td>
            <report-td colspan="3:5" title="供方-自检报告批准结论">
              <span v-if="mainData.supplyAuditStatus === 'R' " class="dangerColor">驳回</span>
              <span v-else-if="mainData.supplyAuditStatus === 'Y' " class="successColor">通过</span>
              <span v-else></span>
            </report-td>
          </tr> -->
          <tr class="myTr1">
            <!-- 自检报告审核人 -->
            <report-td-new colspan="3:5" :title="h_i18n('8b7a5a162942b830d5b7868355f9f719')">
              <span v-if="tableList.isTemplet == 'Y'">{{ $route.query.dataFrom == 'sqm' ? "-" : typeToValue(tableList.supplyCheckApprovorName) }}</span>
              <span v-else>{{ $route.query.dataFrom == 'sqm' ? "-" : typeToValue(mainData.checkMan) }}</span>
            </report-td-new>

            <!-- 自检报告应审核时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('05f9e2c7f925879b0a65e11c61e855b9')">
              <span v-if="tableList.isTemplet == 'Y'">{{ time(tableList.planSupplyCheckDate, 3) }}</span>
              <span v-else>{{ time(tableList.planSupplyCheckDate, 3) }}</span>
            </report-td-new>

            <!-- 自检报告审核时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('08509f6e5a221d7f12852aaaf81c3433')">
              <span v-if="tableList.isTemplet == 'Y'">{{ time(tableList.supplyCheckDate, 6) }}</span>
              <span v-else>{{ time(tableList.supplyCheckDate, 6) }}</span>
              </report-td-new>
          </tr>
          <tr>
            <!-- 审核结论 -->
            <report-td-new colspan="3:21" :title="h_i18n('8c4ab5982fcea30b260715ac494e7922')" v-if="tableList.isTemplet == 'Y'">
              <!-- 不合格；自检报告 -->
              <span v-if="tableList.documentConclusion === 'F' " class="dangerColor">{{ h_i18n('fba16084b4fffdff164a06e4f7f750e3') }}<span style="color: #2b3af8; cursor: pointer" @click="openTempletDetail">{{ h_i18n('497c8434bc60bc8e338faea5d44a6b6d') }}</span></span>
              <!-- 合格；自检报告 -->
              <span v-else-if="tableList.documentConclusion === 'P' " class="successColor">{{ h_i18n('a6f05a1df8aa6847742902a687f161d1') }}<span style="color: #2b3af8; cursor: pointer" @click="openTempletDetail">{{ h_i18n('497c8434bc60bc8e338faea5d44a6b6d') }}</span></span>
              <!-- 打回；自检报告 -->
              <span v-else-if="tableList.documentConclusion === 'R' " class="warningColor">{{ h_i18n('5f00a767c925cce7674c32811ee23a9d') }}<span style="color: #2b3af8; cursor: pointer" @click="openTempletDetail">{{ h_i18n('497c8434bc60bc8e338faea5d44a6b6d') }}</span></span>
              <span v-else></span>
              <!-- {{ checkStatusM(mainData.checkStatus) }} -->
            </report-td-new>
            <!-- 审核结论 -->
            <report-td-new colspan="3:21" :title="h_i18n('8c4ab5982fcea30b260715ac494e7922')" v-else>
              <!-- 不合格；自检报告 -->
              <span v-if="mainData.checkStatus === 'F' " class="dangerColor">{{ h_i18n('fba16084b4fffdff164a06e4f7f750e3') }}<span style="color: #2b3af8; cursor: pointer" @click="openApqpDetail">{{ h_i18n('497c8434bc60bc8e338faea5d44a6b6d') }}</span></span>
              <!-- 合格；自检报告 -->
              <span v-else-if="mainData.checkStatus === 'P' " class="successColor">{{ h_i18n('a6f05a1df8aa6847742902a687f161d1') }}<span style="color: #2b3af8; cursor: pointer" @click="openApqpDetail">{{ h_i18n('497c8434bc60bc8e338faea5d44a6b6d') }}</span></span>
              <!-- 打回；自检报告 -->
              <span v-else-if="mainData.checkStatus === 'R' " class="warningColor">{{ h_i18n('5f00a767c925cce7674c32811ee23a9d') }}<span style="color: #2b3af8; cursor: pointer" @click="openApqpDetail">{{ h_i18n('497c8434bc60bc8e338faea5d44a6b6d') }}</span></span>
              <span v-else></span>
              <!-- {{ checkStatusM(mainData.checkStatus) }} -->
            </report-td-new>
          </tr>
        </form-body-new>
        <!-- 物料检验 -->
        <form-body-new v-else-if="value===h_i18n('f6ef08d35df7a465a265e6283ce8b80c')">
          <tr class="myTr">
            <!-- 供方应送样时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('b7f7ec8161db69beee7dde3b24d168c1')">{{ time(tableList.supplierSendFactorySamplePlanDate, 3) }}</report-td-new>
            <!-- 供方预计送样时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('21aae0f4fa55c7e1ccc74821973449da')">{{ time(tableList.planDeliveryDate, 3) }}</report-td-new>
            <!-- 供方实际送样时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('933ab8a51d8119aa7c08431786478d2c')">{{ time(tableList.supplySendSampleDate, 6) }}</report-td-new>
            <!-- <report-td colspan="3:5"></report-td> -->
          </tr>
          <tr>
            <!-- 供方送样人 -->
            <report-td-new colspan="3:5" :title="h_i18n('6a52ae8d38d65d94a9673129041ca156')">{{ typeToValue(tableList.supplySendSampleMan) }}</report-td-new>
            <!-- <report-td colspan="3:5" title="外检收样时间">{{ typeToValue(tableList.sqeAffirmDate) }}</report-td> -->
            <!-- 供方送样方式 -->
            <report-td-new colspan="3:5" :title="h_i18n('b79c2c2ca46c980cddc5577c8c7d260b')">{{ typeToValue(tableList.deliveryType) }}&nbsp;{{ tableList.deliveryNo }}</report-td-new>
            <!-- 供方送样数量 -->
            <report-td-new colspan="3:5" :title="h_i18n('0a5b1df588a1e061097183d52c2d585b')">{{ typeToValue(tableList.supplySendSampleNumber) }}</report-td-new>
          </tr>
          <tr>
            <!-- 供方样件照片 -->
            <report-td-new colspan="3:13" :title="h_i18n('8ddd98ea8c1604d7f5a40026c5b7d6e1')">
              <div class="picture-list">
                <div class="picture-item h-global-font--blue" v-for="item in typePicture(tableList.samplePicture)" @click="lookPicture(item.filePath)">{{ item.fileName }}</div>
              </div>
            </report-td-new>
            <!-- 外检收样打回次数 -->
            <report-td-new colspan="3:5" :title="h_i18n('9ec6d1e0c2004c5f49888ad7dcb7458d') + h_i18n('f965fea30858da6b154464a16271116d') + '('+ h_i18n('7229ecc63125adf7fcf2867d792a77be') +')'">
              {{ typeToValue(tableList.iqcReceiveSampleBackCount) }}
              <!-- 送样历史 -->
              <span style="padding-left:8px; color: #2b3af8; cursor: pointer" @click="sampleLog(beforeData.patternPlanId)">{{ h_i18n('480314fec74c7ad31c65e15658d015fa') + h_i18n('c827d8dbb76ce33219f64c6749893159') }}</span>
            </report-td-new>
            <report-td-new colspan="3:5"></report-td-new>
          </tr>
          <tr>
            <!-- <report-td colspan="3:5" title="供方送样方式">{{ typeToValue(tableList.deliveryType) }}{{ typeToValue(tableList.deliveryNo) }}</report-td> -->
            <!-- 外检应收样时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('0ddd4226a4bd92090a29418b1972ca2e')">{{ time(tableList.planReceiveDate,3) }}</report-td-new>
            <!-- 外检收样时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('b82ccc7824d23dbf6a23550e8c0ab741')">{{ typeToValue(tableList.sqeAffirmDate) }}</report-td-new>
            <!-- 外检收样数量 -->
            <report-td-new colspan="3:5" :title="h_i18n('95cc6dccd100504563f588ffa2bee106')">{{ typeToValue(tableList.iqcReceiveSampleNumber) }}</report-td-new>
            <!-- <report-td colspan="3:5" title="检验收样人">{{ $route.query.dataFrom == 'sqm' ? "-" : typeToValue(tableList.sqeAffirmMan) }}</report-td> -->
          </tr>
          <tr>
            <!-- 检验收样人 -->
            <report-td-new colspan="3:5" :title="h_i18n('07dfd2b0d14db693b9e842cfdb95c1c8')">{{ $route.query.dataFrom == 'sqm' ? "-" : typeToValue(tableList.sqeAffirmMan) }}</report-td-new>
            <!-- 检验预计完成时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('59d24d279109b32e1cec5ff0a59214bd')">{{ time(tableList.wjPlanCheckDate, 3) }}</report-td-new>
            <!-- <report-td colspan="3:5" title="检验开始时间">{{ time(tableList.sqeAffirmDate, 6) }}</report-td> -->
            <!-- <report-td colspan="3:5" title="收样状态">{{ tableList.isSendFactoryTemp === "Y" ? "已收样" : tableList.isSendFactoryTemp === "N" ? "未送样" : "-" }}</report-td>
            <report-td colspan="3:5" title="模块检验结论">
              <span v-if="tableList.testConclusion === 'F' " class="dangerColor">不合格&nbsp;&nbsp;<span style="color: #2b3af8; cursor: pointer" @click="openTestDetail">检验报告</span></span>
              <span v-else-if="tableList.testConclusion === 'P' " class="successColor">合格&nbsp;&nbsp;<span style="color: #2b3af8; cursor: pointer" @click="openTestDetail">检验报告</span></span>
              <span v-else></span>
            </report-td> -->
            <!-- <report-td colspan="3:5" title="检验预计完成时间">{{ time(tableList.wjPlanCheckDate, 6) }}</report-td> -->
            <!-- 检验完成时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('8c0f6280ef5a832cd3cfa8cd664800b5')">{{ time(tableList.checkCompleteDate, 6) }}</report-td-new>
          </tr>
          <tr class="myTr1">
            <!-- <report-td-new colspan="3:5" title="检验时长" question>
              <template #tipText>
                检验时长=外检经理检验完成的时间-外检经理收样时间
              </template>
              {{ typeToValue(tableList.totalTime) }}</report-td-new> -->
            <!-- 模块检验结论 -->
            <report-td-new colspan="3:21" :title="h_i18n('f06fabd3bbb027dc396ef4515687a39c')">
              <!-- 不合格；检验报告 -->
              <span v-if="tableList.testConclusion === 'F' " class="dangerColor">{{ h_i18n('fba16084b4fffdff164a06e4f7f750e3') }}<span style="color: #2b3af8; cursor: pointer" @click="openTestDetail">{{ h_i18n('8995232b8db82519b843a940a48a5829') }}</span></span>
              <!-- 合格；检验报告 -->
              <span v-else-if="tableList.testConclusion === 'P' " class="successColor">{{ h_i18n('a6f05a1df8aa6847742902a687f161d1') }}<span style="color: #2b3af8; cursor: pointer" @click="openTestDetail">{{ h_i18n('8995232b8db82519b843a940a48a5829') }}</span></span>
              <span v-else></span>
            </report-td-new>
          </tr>
        </form-body-new>
        <!-- <form-body v-else-if="value==='研发确认'">
          <tr>
            <report-td colspan="3:5" title="供方送研发样">{{ typeToValue(tableList.a) }}</report-td>
            <report-td colspan="3:5" title="研发确认人">{{ typeToValue(tableList.a) }}</report-td>
            <report-td colspan="3:5" title="研发确认时间">{{ typeToValue(tableList.a) }}</report-td>
          </tr>
        </form-body> -->
        <!-- 制版设计稿 -->
        <form-body-new v-else-if="value===h_i18n('2f4fd79b3f9b4a273afa62295ab7db6a') && tableList.isTemplet == 'Y'">
          <tr class="myTr">
            <!-- 供方制版设计稿提交人 -->
            <report-td-new colspan="3:5" :title="h_i18n('508477ae34698ffece847464ca2539cb')">{{ tableList.pictureSubmitMan }}</report-td-new>
            <!-- <report-td-new colspan="3:5" title="供方应提交制版设计稿时间"></report-td-new> -->
            <!-- 供方实际提交制版设计稿时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('87dd7ebd36d4b5948f3c5f313dd4e331')">{{ time(tableList.pictureFileTime,6) }}</report-td-new>
            <!-- 制版设计稿应审核时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('25586c3416312378ba9c49161a9d120e')"></report-td-new>
          </tr>
          <tr class="myTr1">
            <!-- 制版设计稿实际审核时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('33f90c1809e0dde6c985bf4bd2b2dc94')">{{ time(tableList.pictureCheckTime,6) }}</report-td-new>
            <!-- 制版设计稿审核人 -->
            <report-td-new colspan="3:5" :title="h_i18n('935f047ef8b4e85f896e69d7d497604a')">{{ $route.query.dataFrom == 'sqm' ? "-" : typeToValue(tableList.careerManName) }}</report-td-new>
            <!-- 制版设计稿审核结论 -->
            <report-td-new colspan="3:5" :title="h_i18n('044c5a725f39e24a5253e784e48c97ee')">
              <!-- 不合格 -->
              <span v-if="tableList.pictureCheckConclusion === 'F' " class="dangerColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
              <!-- 合格 -->
              <span v-else-if="tableList.pictureCheckConclusion === 'P' " class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
              <span v-else></span>
            </report-td-new>
          </tr>
        </form-body-new> 
        <!-- 外检结论 -->
        <form-body-new v-else-if="value===h_i18n('4112c666805c8646fa5fc69a453f2f88')">
          <!-- <template v-if="tableList.isTemplet == 'Y'">
            <tr>
              <report-td colspan="3:5" title="校核结论">
                <span v-if="tableList.auditfinal === 'Y' " class="dangerColor">不合格</span>
                <span v-else-if="tableList.auditfinal === 'P' " class="successColor">合格</span>
                <span v-else></span>
              </report-td>
              <report-td colspan="3:5" title="检验结论校核时间">{{ time(tableList.iqcLeaderAuditDate, 6) }}</report-td>
              <report-td colspan="3:5" title="检验结论校核人">{{ $route.query.dataFrom == 'sqm' ? "-" : tableList.iqcLeaderName }}</report-td>
            </tr>
            <tr>
              <report-td colspan="3:21" title="校核意见">
                {{ tableList.supplyCheckApproveMark }}
              </report-td>
            </tr>
          </template>
          <template v-else> -->
            <!-- <tr class="myTr">
              <report-td-new colspan="3:5" title="检验结论校核人">{{ $route.query.dataFrom == 'sqm' ? "-" : tableList.iqcLeaderAuditApprovorName }}</report-td-new>
              <report-td-new colspan="3:5" title="检验结论应校核时间">{{ time(tableList.iqcLeaderAuditPlanDate, 3) }}</report-td-new>
              <report-td-new colspan="3:5" title="检验结论校核时间">{{ time(tableList.iqcLeaderAuditDate, 6) }}</report-td-new>
            </tr>
            <tr class="myTr1">
              <report-td-new colspan="3:5" title="校核结论">
                <span v-if="tableList.iqcLeaderConclusion === 'F' " class="dangerColor">不合格</span>
                <span v-else-if="tableList.iqcLeaderConclusion === 'P' " class="successColor">合格</span>
                <span v-else></span> -->
                <!-- {{ tableList.iqcLeaderConclusion === "P" ? "合格" : tableList.iqcLeaderConclusion === "F" ? "不合格" : "-" }} -->
              <!-- </report-td-new>
              <report-td-new colspan="3:13" title="校核意见">
                {{ tableList.iqcLeaderMark }}
              </report-td-new>
            </tr> -->
            <template v-if="tableList.isTemplet === 'Y'">
              <!-- 显示模板库和检验 校核结果 -->
              <!-- 文件结论： -->
              <h-tr class="myTr">{{ h_i18n('e0cbe57ef236d52e7fa5bd3e9469f82f') }}</h-tr>
              <tr>
                <!-- 外检负责人 -->
                <report-td colspan="3:5" :title="h_i18n('fc4ed0419f8799cba7678812a2e3eae1')">-</report-td>
                <!-- 负责人应校核时间 -->
                <report-td colspan="3:5" :title="h_i18n('81ba6fb7bdd608d11a62f36c64d566cf')">{{ time(tableList.iqcLeaderAuditPlanDate, 3) }}</report-td>
                <!-- 负责人实校核时间 -->
                <report-td colspan="3:5" :title="h_i18n('817c4f1106e7b95004de04245da617dd')">{{ time(tableList.iqcLeaderAuditDate, 6) }}</report-td>
              </tr>
              <tr>
                <!-- 外检负责人校核结论 -->
                <report-td colspan="3:5" :title="h_i18n('50870b5c342d62e61dad40cafd007ace')">
                  <!-- 不合格 -->
                  <span v-if="tableList.iqcLeaderConclusion === 'F' " class="warningColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                  <!-- 合格 -->
                  <span v-else-if="tableList.iqcLeaderConclusion === 'P' " class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                  <!-- 打回 -->
                  <span v-else-if="tableList.iqcLeaderConclusion === 'R' " class="dangerColor">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</span>
                  <span v-else></span>
                </report-td>
                <!-- 外检负责人校核意见 -->
                <report-td colspan="3:13" :title="h_i18n('ac42ce6b7e74022c9a7a77037b138f30')">
                  {{ tableList.iqcLeaderMark }}
                </report-td>
              </tr>
            </template>
            <template v-else>
              <!-- 显示自检和检验 校核结果 -->
              <!-- 文件结论： -->
              <h-tr class="myTr">{{ h_i18n('e0cbe57ef236d52e7fa5bd3e9469f82f') }}</h-tr>
              <tr>
                <!-- 外检负责人 -->
                <report-td colspan="3:5" :title="h_i18n('fc4ed0419f8799cba7678812a2e3eae1')">-</report-td>
                <!-- 负责人应校核时间 -->
                <report-td colspan="3:5" :title="h_i18n('81ba6fb7bdd608d11a62f36c64d566cf')">{{ time(tableList.iqcLeaderAuditPlanDate, 3) }}</report-td>
                <!-- 负责人实校核时间 -->
                <report-td colspan="3:5" :title="h_i18n('817c4f1106e7b95004de04245da617dd')">{{ time(tableList.iqcLeaderAuditDate, 6) }}</report-td>
              </tr>
              <tr>
                <!-- 外检负责人校核结论 -->
                <report-td colspan="3:5" :title="h_i18n('50870b5c342d62e61dad40cafd007ace')">
                  <!-- 不合格 -->
                  <span v-if="tableList.iqcLeaderConclusion === 'F' " class="warningColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                  <!-- 合格 -->
                  <span v-else-if="tableList.iqcLeaderConclusion === 'P' " class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                  <!-- 打回 -->
                  <span v-else-if="tableList.iqcLeaderConclusion === 'R' " class="dangerColor">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</span>
                  <span v-else></span>
                </report-td>
                <!-- 外检负责人校核意见 -->
                <report-td colspan="3:13" :title="h_i18n('ac42ce6b7e74022c9a7a77037b138f30')">
                  {{ tableList.iqcLeaderMark }}
                </report-td>
              </tr>
            </template>
            <!-- 物料结论： -->
            <h-tr>{{ h_i18n('1b7be964f24efcfde45415a360f5cfa6') }}</h-tr>
            <tr>
              <!-- 外检负责人 -->
              <report-td colspan="3:5" :title="h_i18n('fc4ed0419f8799cba7678812a2e3eae1')">-</report-td>
              <!-- 负责人应校核时间 -->
              <report-td colspan="3:5" :title="h_i18n('81ba6fb7bdd608d11a62f36c64d566cf')">{{ time(tableList.iqcLeaderMaterialAuditPlanDate, 3) }}</report-td>
              <!-- 负责人实校核时间 -->
              <report-td colspan="3:5" :title="h_i18n('817c4f1106e7b95004de04245da617dd')">{{ time(tableList.iqcLeaderMaterialAuditDate, 6) }}</report-td>
            </tr>
            <tr class="myTr1">
              <!-- 外检负责人校核结论 -->
              <report-td colspan="3:5" :title="h_i18n('50870b5c342d62e61dad40cafd007ace')">
                <!-- 不合格 -->
                <span v-if="tableList.iqcLeaderMaterialConclusion === 'F' " class="warningColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                <!-- 合格 -->
                <span v-else-if="tableList.iqcLeaderMaterialConclusion === 'P' " class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                <!-- 打回 -->
                <span v-else-if="tableList.iqcLeaderMaterialConclusion === 'R' " class="dangerColor">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</span>
                <span v-else></span>
              </report-td>
              <!-- 外检负责人校核意见 -->
              <report-td colspan="3:13" :title="h_i18n('ac42ce6b7e74022c9a7a77037b138f30')">
                {{ tableList.iqcLeaderMaterialMark }}
              </report-td>
            </tr>
          <!-- </template> -->
        </form-body-new>
        <!-- 开发总结论 -->
        <form-body-new v-else-if="value===h_i18n('74efc164b99926adcc8746ded2434e15')">
          <tr class="myTr">
            <!-- 开发结论确认人 -->
            <report-td-new colspan="3:5" :title="h_i18n('85ab5b4c4d5bc07d47293c99cbc3f3f6')">{{$route.query.dataFrom == 'sqm' ? "-" : tableList.careerConclusionMan }}</report-td-new>
            <!-- 开发结论确认时间 -->
            <report-td-new colspan="3:5" :title="h_i18n('0159b339fa426e9d955243e870b8ba02')">{{ time(tableList.careerConclusionDate,6) }}</report-td-new>
            <!-- 开发结论 -->
            <report-td-new colspan="3:5" :title="h_i18n('027c72c524eae3b5d8b7d564e18ffa0d')">
              <!-- 不合格 -->
              <span v-if="tableList.careerConclusionMark === 'F' " class="dangerColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
              <!-- 合格 -->
              <span v-else-if="tableList.careerConclusionMark === 'P' " class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
              <span v-else></span>
              <!-- {{ typeCheckD(tableList.careerConclusionMark) }} -->
            </report-td-new>
          </tr>
          <tr class="myTr1">
            <!-- 开发意见 -->
            <report-td-new colspan="3:21" :title="h_i18n('5533165b2374c16d0a8d93a70c5d9e60')">{{ tableList.careerConclusionRemark }}</report-td-new>
          </tr>
        </form-body-new>
      </template>
      <template #footer>
        <h-button-group align="center">
          <!-- 返回 -->
          <h-button type="default" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </form-area-new>
  </h-form-page-new>
  <!-- 送样历史记录 -->
    <h-dialog :show="historyShow" :title="h_i18n('480314fec74c7ad31c65e15658d015fa') + h_i18n('c827d8dbb76ce33219f64c6749893159')" 
       @close="historyCancel" width="70%" class="picUp_dialog_style">
      <div class="history-table">
        <!-- 暂无数据 -->
        <el-table :data="historyTable" v-loading="historyLoading" :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" 
          height="540" border size="small" style="width: 100%;min-height: 340px;">
          <!-- 序号 -->
          <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="62"></el-table-column>
          <!-- 状态 -->
          <el-table-column prop="sampleStatus" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="80">
             <template #default="{ row }">
               <!-- 打回 -->
               <el-tag size="small" v-if="row.sampleStatus === 2221" type="danger">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</el-tag>
               <!-- 通过 -->
               <el-tag size="small" v-else-if="row.sampleStatus === 2222" type="success">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</el-tag>
               <span v-else>-</span>
             </template>
          </el-table-column>
          <!-- 供方计划送样时间 -->
          <el-table-column prop="supplierSendFactorySamplePlanDate" :label="h_i18n('8e20b70327602db813a03df90b7a9ed8')" width="150" >
            <template #default="{ row }">{{ row.supplierSendFactorySamplePlanDate ? time(row.supplierSendFactorySamplePlanDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 供方送样人 -->
          <el-table-column prop="supplySendSampleMan" :label="h_i18n('6a52ae8d38d65d94a9673129041ca156')" width="120" >
            <template #default="{ row }">{{ row.supplySendSampleMan || '-' }}</template>
          </el-table-column>
          <!-- 供方送样数量 -->
          <el-table-column prop="supplySendSampleNumber" :label="h_i18n('0a5b1df588a1e061097183d52c2d585b')" width="120">
            <template #default="{ row }">{{ row.supplySendSampleNumber || '-' }}</template>
          </el-table-column>
          <!-- 送样方式 -->
          <el-table-column prop="deliveryType" :label="h_i18n('195fe52c72f3f8c6be34c497b47c94bc')" width="100" ></el-table-column>
          <!-- 快递单号 -->
          <el-table-column prop="deliveryNo" :label="h_i18n('3c016d36581bc71c027386cbf617722f')" width="150" >
            <template #default="{ row }">{{ row.deliveryNo || '-' }}</template>
          </el-table-column>
          <!-- 预计送样时间 -->
          <el-table-column prop="planDeliveryDate" :label="h_i18n('5ad67a9e2faec80e40f03e924c59dc43')" width="150" >
            <template #default="{ row }">{{ row.planDeliveryDate ? time(row.planDeliveryDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 送样拖期原因 -->
          <el-table-column prop="sendSampleDelayReason" :label="h_i18n('01A3AD4C38FDCDB333EF79759E011F67')" width="150" >
            <template #default="{ row }">
               {{ resonName(row.sendSampleDelayReason) || '-'}}
            </template>
          </el-table-column>
          <!-- 送样拖期其他原因说明 -->
          <!-- 送样拖期其它原因说明 -->
          <el-table-column prop="sendSampleDelayReasonRemark" :label="h_i18n('D5D682769E2FD411333DB100B9A6AD3E')" width="190" >
            <template #default="{ row }">{{ row.sendSampleDelayReasonRemark || '-' }}</template>
          </el-table-column>
          <!-- 送样样件照片 -->
          <el-table-column prop="samplePicture" :label="h_i18n('1bde84c9de69d3fb8ad01e70a14455df')" width="320" class-name="photoColumn" >
            <template #default="{ row }">
              <template v-for="(item, i) in typePicture(row.samplePicture)" :key="i">
                <a :href="$filePathSplicing(item.filePath)" target="_blank" style="display:none;"></a>
                <el-image :src="$filePathSplicing(item.filePath, 'img')" :preview-src-list="typePicture(row.samplePicture).map(u => $filePathSplicing(u.filePath, 'img'))"
                  style="width:27px ; height:27px;margin-right: 2px; vertical-align: text-top;object-fit:fill;border-radius: 4px;"
                  fit="fill" preview-teleported="true">
                </el-image>
              </template>
            </template>
          </el-table-column>
          <!-- 实际送样时间 -->
          <el-table-column prop="supplySendSampleDate" :label="h_i18n('3f35655dd0d0598a1441faad74ac5d40')" width="150" >
            <template #default="{ row }">{{ row.supplySendSampleDate ? time(row.supplySendSampleDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 收样数量 -->
          <el-table-column prop="iqcReceiveSampleNumber" :label="h_i18n('f9c946f168fef4b7ac270ad2dee628fb')" width="100">
            <template #default="{ row }">{{ row.iqcReceiveSampleNumber || '-' }}</template>
          </el-table-column>
          <!-- 收样时间 -->
          <!-- 检验收样时间 -->
          <el-table-column prop="sqeAffirmDate" :label="h_i18n('296b2d40f689d423ab3dd66889c76fde')" width="150" >
            <template #default="{ row }">{{ row.sqeAffirmDate ? time(row.sqeAffirmDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 收样意见 -->
          <el-table-column prop="sqeAffirmMark" :label="h_i18n('b9bca46ff88c72b2d00059ff9b2ed396')" width="200" >
            <template #default="{ row }">{{ row.sqeAffirmMark || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </h-dialog>
</template>





<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';


export default {
  name: "SampleInspectionFormLook",
  data() {
    return {
      name: '',
      nickName: '',
      auditStatus: '',
      auditConclusions: '',
      tableList: {},
      inspectionMethod: [
        // 新品标准检
        {value: "1104", label: h_i18n('07776c59765079b72e7b52cf69d7724c')},
        // 新品免检
        {value: "1105", label: h_i18n('860c31139e636c2fc05e6dc5faf071bf')},
        // 新品加速检
        {value: "1106", label: h_i18n('aaedacb2e922bd7a5b98f05e4e6c06f6')},
        // 新品停检
        {value: "1141", label: h_i18n('6af02ad416e5589fcc3fcb9e89d30e31')},
      ],
      supplyCheckList: [
        {value: "1010", label: "AQC"},
        {value: "1011", label: "BQC"},
        {value: "1012", label: "RQC"},
        {value: "1153", label: "LQC"},
      ],
      beforeData: {},
      mainData: {},
      templetData:{submitMan:''},
      historyShow:false,// 送样历史弹窗
      historyTable: [],
      historyLoading: false,
      sendSampleDelayReasonData:[],
    }
  },
  methods: {
    h_i18n,
    checkStatusM(value) {
      if (value === "P") {
        // 通过
        return h_i18n('23c1f39900b3af4c3263449782e288e1')
      } else if (value === "F") {
        // 不通过
        return h_i18n('dec0624c91cfca219e1b41ce89c19780')
      } else if (value === "R") {
        // 打回
        return h_i18n('9a7b15dccc5cda2e3db1110678576104')
      } else {
        return ""
      }
    },
    supplyAuditStatusM(value) {
      if (value === "Y") {
        // 通过
        return h_i18n('23c1f39900b3af4c3263449782e288e1')
      } else if (value === "R") {
        // 驳回
        return h_i18n('32525478cd5c1c93de9c71246021b595')
      } else {
        return ""
      }
    },
    supplyCheckFormatter(data) {
      if (!data) return "-"
      let a = this.supplyCheckList.filter(v => v.value === data.toString())[0]
      if (!a) return "-"
      return a.label
    },
    typeToValue(value, type = "-") {
      if (value) return value
      return type
    },
    lookPicture(url) {
      window.open(url)
    },
    // 送样历史查询
    sampleLog(patternPlanId){
      let obj = {
        patternPlanId: patternPlanId,
        pageNo: 1,
        pageSize: 99,
      }
      this.$http({
        url:'/base/sendSampleLog/listPage',
        method:'post',
        data:obj
      }).then(res=>{
        if(res.data.code === '200'){
          if(res.data?.data?.records.length > 0){
            this.historyTable = res.data.data.records
            this.historyShow = true
          }else{
            // 暂无；送样；历史
            this.warning(h_i18n('f61f4cf6d0d544fad4507868b74696a1')+(h_i18n('480314fec74c7ad31c65e15658d015fa') + h_i18n('c827d8dbb76ce33219f64c6749893159')))
            this.historyTable = []
            this.historyShow = false
          }
        } else {
          this.warning(res.data?.msg)
          this.historyTable = []
          this.historyShow = false
        }
      }).catch(err=>{
        console.log(err)
      }).finally(()=>{
        this.historyLoading = false
      })
    },
    // 关闭送样历史
    historyCancel(){
      this.historyShow = false
      this.historyTable = []
    },
    // 送样拖期原因名
   resonName (id) {
    return this.sendSampleDelayReasonData.find(item=>{
        return item.value === id
      })?.label
    },
    // 查询状态表
    getBaseValues(){
      this.$http({
        method: "post",
        url: "/base/basicData/listBaseValuesByIds",
        data: [112],
      }).then((res) => {
        if (res.data.code === "200") {
          res.data.data.forEach(item=>{
            // 拖期原因走配置表
            if(item.valueTypeId === 112){
              this.sendSampleDelayReasonData.push({value:item.valueId,label:item.valueName})
            }
          })
        } else {
        }
      }).catch((err) => {
      });

    },
    typePicture(list) {
      if (list) {
        return list.split(",").map(v => {
          let l = v.split("£™£")
          return {
            filePath: l[0],
            fileName: l[1]
          }
        })
      }
    },
    typeCheckD(text) {
      if (text === "P") {
        // 合格
        return h_i18n('86f720320b77bb62311f0a4811db04fe')
      } else if (text === "F") {
        // 不合格
        return h_i18n('6e5a122013138ad189517d5d0a1c0891')
      } else {
        return ""
      }
    },
    inspectionUpdate(height) {
      this.postThisPageHeight()
    },
    searchTableList() {
      // 数据查询中
      this.startLoading(h_i18n('8f64f3e8f07e9b00a0eca21f01a208c6'))
      this.$http({
        method: "get",
        url: "/base/patternPlan/searchPatternPlanInfo?patternPlanId=" + this.beforeData.patternPlanId,
      }).then((res) => {
        this.closeLoading()
        if (res.data.code === "200" && res.data.data) {
          this.tableList = res.data.data.patternPlan
          this.mainData = res.data.data.apqpMain ? res.data.data.apqpMain : {}
          this.templetData = res.data.data.templetData ? res.data.data.templetData : {submitMan:''}
        } else {
          // 数据查询失败
          this.error(h_i18n('57738c8a6a20c40f544b2f5c17447298'))
        }
      }).catch((err) => {

      });
    },
    openTempletDetail(){
      if(this.beforeData.patternPlanId){
        if(this.tableList.isTemplet == 'Y'){ // 衍生资料模板库 / 免检 / 新品模板库
          this.$router.push({
            name: "DetailTemplate",
            query: {
              name: this.$route.query.name,
              nickName: this.$route.query.nickName,
              patternPlanId:this.beforeData.patternPlanId,
              data: JSON.stringify(this.beforeData),
            }
          });
        }
      }
    },
    openApqpDetail(){
      if(this.$route.query.dataFrom == 'sqm'){
        this.$router.push({
          name: "RepulseSelfInspectionLook",
          query: {
            name: this.$route.query.name,
            nickName: this.$route.query.nickName,
            dataFrom:'sqm',
            data: JSON.stringify(this.beforeData),
          },
        });
      }else{
        this.$router.push({
          name: "DetailSelfInspectionData",
          query: {
            name: this.$route.query.name,
            nickName: this.$route.query.nickName,
            data: JSON.stringify(this.beforeData),
          },
        });
      }
    },
    openTestDetail(){
      this.beforeData.mtlNo = this.tableList.mtlNo
      this.$router.push({
        name: "NewProductInspectionTask/InspectionPlanView",
        query: {
          name: this.$route.query.name,
          nickName: this.$route.query.nickName,
          data: JSON.stringify(this.beforeData),
          dataFrom:'sqm',
        },
      });
    }
  },
  mounted() {
    if (this.$route.query.name) {
      this.name = this.$route.query.name
      this.nickName = this.$route.query.nickName
    }
    this.beforeData.patternPlanId = this.$route.query.patternPlanId
    this.getBaseValues()
    this.searchTableList()
    this.postThisPageHeightMore()
  }
}
</script>

<style scoped>
.h-hwork-form-page{
  width: 98%;
  margin: 0 auto;
}
.haier-title-lable{
  height: 48px;
  background: #fff;
}
.haier-form-area{
  background: #F2F4F7;
}
.haier-form-area .area .h-work-d-body{
  padding: 0;
}
</style>

<style lang="scss" scoped>
.input_rows_style {
  .el-textarea__inner {
    height: auto;
  }
}

.picture-list {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}
.detail-content{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 15px;
  .detail-item{
    width: 25%;
    display: flex;
    .item-label{
      min-width: 45px;
      font-size: 14px;
      color: #4E5969;
    }
    .item-content{
      font-size: 14px;
      color: #1D2129;
    }
  }
}
.myTr :first-child{
  border-top-left-radius: 8px;
  // border-top-right-radius: 8px;
}
.myTr :last-child{
  border-top-right-radius: 8px;
  // border-bottom-right-radius: 8px;
}
.myTr1 :first-child {
  border-bottom-left-radius: 8px;
  // border-top-right-radius: 8px;
}
.myTr1 :last-child{
  border-bottom-right-radius: 8px;
  // border-bottom-right-radius: 8px;
}
</style>